import React, { useEffect, useReducer, useState } from "react";
import DashboardContainer from "../../components/dashboard-container";
import { Box, CircularProgress, IconButton, Tooltip } from "@mui/material";
import CategoryList from "../../components/category-list";
import CategoryModal from "../../components/category-modal";
import CustomPagination from "../../components/pagination";
import { categoryService } from "../../utils/services/categoryService";
import buildQuery from "../../utils/query-builder";
import { filterReducer } from "../../utils/filterConfig";
import { categoryFilterConfig } from "../../utils/filter-config";

export default function Category() {
  const clientId = localStorage.getItem("client_id");

  const [filterData, dispatch] = useReducer(
    filterReducer,
    categoryFilterConfig,
  );
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [page, setPage] = useState(0);
  const [dataCount, setDataCount] = useState(0);

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const query = buildQuery(filterData, page);
      const response = await categoryService.fetchRoots(
        searchValue,
        query,
        clientId,
      );
      setCategories(response?.data || []);
      setDataCount(response?.total || 0);
    } catch (error) {
      console.error("Fetch categories failed:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, [page, filterData, searchValue]);

  const handleFilterChange = (newFilter) => {
    dispatch({ type: "SET_FILTER", payload: newFilter });
    setPage(0);
  };

  return (
    <>
      <DashboardContainer
        searchBarPlaceholder="Search by Category Name"
        onChangeFilter={handleFilterChange}
        filterData={filterData}
        fields={filterData.columns}
        hideFilterClient
        onSearchData={(val) => {
          setSearchValue(val);
          setPage(0);
        }}
        onClickAddButton={() => {
          setSelectedCategory(null);
          setOpenModal(true);
        }}
        hideUploadButton
        header="Category List"
        title="+ Category"
        onClickRefresh={() => fetchCategories()}
        hideGridList
      >
        <CategoryModal
          open={openModal}
          selectedCategory={selectedCategory}
          handleClose={() => {
            setOpenModal(false);
            setSelectedCategory(null);
          }}
          onAddData={fetchCategories}
        />

        <CategoryList
          data={categories}
          onEditData={(category) => {
            setSelectedCategory(category);
            setOpenModal(true);
          }}
          onDeleteData={fetchCategories}
          filterData={filterData}
          onChangeFilter={handleFilterChange}
          currentPage={page}
          itemsPerPage={filterData.limit}
          clientId={clientId}
          loading={loading}
        />

        <CustomPagination
          dataCount={dataCount}
          rowsPerPage={filterData.limit}
          page={page}
          setPage={setPage}
          setRowsPerPage={(val) =>
            dispatch({ type: "UPDATE_LIMIT", payload: val })
          }
        />
      </DashboardContainer>
    </>
  );
}
